<!-- login -->
@if (!hideSpinner) {
  <app-user-spinner></app-user-spinner>
}
<div class="registration-page">
  <div>
    <img class="lesteLogo" src="./assets/icons/LogoLESTE.png" alt="LESTE logo">
    @if (isSuccessfull) {
      <p>Uspešno ste verifikovali svoju email adresu! Bićete uskoro preusmereni ka narednoj stranici,
        ili kliknite na <a routerLink="/login">Sledeći link</a>, ukoliko ne budete preusmereni</p>
      }
      @if (hasFailed) {
        <p>Pogrešan link ili je nalog istekao. Molimo, proverite link koji ste posetili ili pokušajte ponovo da se <a routerLink="/registration">registrujete</a></p>
      }
    </div>
  </div>
